
import s from './Education'
export default s
